// extracted by mini-css-extract-plugin
export default {"container":"bE-z","dimension":"cE-z","dimensionLabels":"dE-z"};